import { cn } from '@/app/utils/cn'
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from './ui/tooltip'

interface CommissionSemaphoreProps {
  status?: string
  className?: string
}

const statusMap: Record<
  string,
  {
    label: string
    color: string
  }
> = {
  AVAILABLE: {
    label: 'Comissão disponível para saque',
    color: 'bg-success',
  },
  PENDING: {
    label: 'Comissão em andamento',
    color: 'bg-info',
  },
  REFUSED: {
    label: 'Comissão não disponível para saque',
    color: 'bg-error',
  },
}

export const CommissionSemaphore = ({
  status,
  className,
}: CommissionSemaphoreProps) => {
  if (!status) {
    return null
  }

  const statusInfo = statusMap[status]

  if (!statusInfo) {
    return null
  }

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            className={cn(
              'inline-flex h-2 w-2 rounded-full',
              statusInfo.color,
              className,
            )}
          />
        </TooltipTrigger>
        <TooltipContent>
          <p>{statusInfo.label}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
